
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/narzedzia-warsztatowe-wyposazenie/[tytul]/[shortid]/[lang]",
      function () {
        return require("private-next-pages/narzedzia-warsztatowe-wyposazenie/[tytul]/[shortid]/[lang]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/narzedzia-warsztatowe-wyposazenie/[tytul]/[shortid]/[lang]"])
      });
    }
  